const LOCK_TTL_MS = 30 * 60 * 1000;

const createSubmissionId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const getOrderSubmissionLockKey = (siteId) =>
  `si_order_submission_lock_${siteId || "default"}`;

export const getOrderSubmissionIdKey = (siteId) =>
  `si_order_submission_id_${siteId || "default"}`;

export const getActiveOrderSubmissionLock = (siteId) => {
  try {
    const key = getOrderSubmissionLockKey(siteId);
    const rawLock = localStorage.getItem(key);
    if (!rawLock) return null;

    const lock = JSON.parse(rawLock);
    if (!lock?.id) {
      localStorage.removeItem(key);
      return null;
    }

    return {
      ...lock,
      recoveryDue: !lock.expiresAt || lock.expiresAt <= Date.now(),
    };
  } catch (error) {
    return null;
  }
};

export const startOrderSubmissionLock = (siteId, details = {}) => {
  const activeLock = getActiveOrderSubmissionLock(siteId);
  if (activeLock) {
    return { started: false, lock: activeLock };
  }

  const submissionKey = getOrderSubmissionIdKey(siteId);
  let savedSubmission = null;
  try {
    savedSubmission = JSON.parse(localStorage.getItem(submissionKey));
  } catch (error) {
    savedSubmission = null;
  }
  const fingerprintChanged =
    details.cartFingerprint &&
    savedSubmission?.cartFingerprint &&
    details.cartFingerprint !== savedSubmission.cartFingerprint;
  if (!savedSubmission?.id || fingerprintChanged) {
    savedSubmission = {
      id: createSubmissionId(),
      cartFingerprint: details.cartFingerprint || null,
      createdAt: Date.now(),
    };
    localStorage.setItem(submissionKey, JSON.stringify(savedSubmission));
  }

  const lock = {
    id: savedSubmission.id,
    status: "creating_order",
    createdAt: Date.now(),
    expiresAt: Date.now() + LOCK_TTL_MS,
    ...details,
  };

  localStorage.setItem(getOrderSubmissionLockKey(siteId), JSON.stringify(lock));
  return { started: true, lock };
};

export const getOrderSubmissionHeaders = (lock) =>
  lock?.id ? { "Idempotency-Key": lock.id } : {};

export const updateOrderSubmissionLock = (siteId, details = {}) => {
  const activeLock = getActiveOrderSubmissionLock(siteId);
  if (!activeLock) return null;

  const lock = {
    ...activeLock,
    ...details,
    updatedAt: Date.now(),
    expiresAt: Date.now() + LOCK_TTL_MS,
  };

  localStorage.setItem(getOrderSubmissionLockKey(siteId), JSON.stringify(lock));
  return lock;
};

export const clearOrderSubmissionLock = (siteId) => {
  localStorage.removeItem(getOrderSubmissionLockKey(siteId));
};

export const clearOrderSubmissionState = (siteId) => {
  localStorage.removeItem(getOrderSubmissionLockKey(siteId));
  localStorage.removeItem(getOrderSubmissionIdKey(siteId));
};

export const clearAllOrderSubmissionLocks = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith("si_order_submission_lock_"))
      .forEach((key) => localStorage.removeItem(key));
    Object.keys(localStorage)
      .filter((key) => key.startsWith("si_order_submission_id_"))
      .forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    return;
  }
};

export const clearAllOrderSubmissionLocksOnly = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith("si_order_submission_lock_"))
      .forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    return;
  }
};
